import { render, staticRenderFns } from "./AuthorQuote.vue?vue&type=template&id=50da5056&"
import script from "./AuthorQuote.vue?vue&type=script&lang=js&"
export * from "./AuthorQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports